if (!customElements.get('wr-hand-product')) {
  customElements.define('wr-hand-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const root = this.querySelector('[data-hand-reset]');
      const configNode = this.querySelector('[data-hand-config]');
      if (!root || !configNode) return;
      const config = JSON.parse(configNode.textContent);
      const input = this.querySelector('[data-hand-quantity]');
      const minus = this.querySelector('[data-hand-minus]');
      const plus = this.querySelector('[data-hand-plus]');
      const maximum = Math.max(1, Number(input.max) || 99);
      const format = cents => new Intl.NumberFormat(config.locale, {style:'currency',currency:config.currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:cents % 100 ? 2 : 0,maximumFractionDigits:2}).format(cents / 100) + ' ' + config.currency;
      const update = () => {
        const quantity = Math.max(1, Math.min(maximum, Math.floor(Number(input.value) || 1)));
        input.value = String(quantity);
        minus.disabled = quantity <= 1;
        plus.disabled = quantity >= maximum;
        const total = format(config.price * quantity);
        const label = (quantity === 1 ? config.strings.addTotal : config.strings.addMany).replace('__TOTAL__',total).replace('__QUANTITY__',String(quantity));
        this.querySelectorAll('[data-hand-purchase]').forEach(button => {button.textContent = config.available ? label : config.strings.soldOut; button.disabled = !config.available;});
        this.querySelectorAll('[data-hand-summary]').forEach(node => {node.textContent = quantity === 1 ? config.strings.quantityOne : config.strings.quantityMany.replace('__QUANTITY__',String(quantity));});
        this.querySelectorAll('[data-hand-shipping]').forEach(node => {node.textContent = config.currency === 'CAD' && config.price * quantity > 20000 ? config.strings.freeShipping : config.strings.shipping;});
      };
      input.addEventListener('change',update);
      input.addEventListener('input',update);
      minus.addEventListener('click',() => {input.value = String(Number(input.value) - 1); update();});
      plus.addEventListener('click',() => {input.value = String(Number(input.value) + 1); update();});
      this.querySelectorAll('[data-hand-photo]').forEach(button => button.addEventListener('click',() => {
        const image = this.querySelector('[data-hand-hero]');
        image.src = button.dataset.handPhoto;
        image.alt = button.dataset.handAlt;
        image.height = button.dataset.handPhoto.includes('wr-hand-still') ? 683 : 1536;
        this.querySelectorAll('[data-hand-photo]').forEach(item => {const active = item === button; item.classList.toggle('active',active); item.setAttribute('aria-pressed',String(active));});
      }));
      this.querySelectorAll('a[href="#return-answer"],a[href="#warranty-answer"]').forEach(link => link.addEventListener('click', () => {
        const details = this.querySelector(link.getAttribute('href'));
        if (details) details.open = true;
      }));
      const sticky = this.querySelector('[data-hand-sticky]');
      if (sticky && 'IntersectionObserver' in window) {
        let pastHero = false;
        let finalVisible = false;
        const updateSticky = () => {
          const visible = pastHero && !finalVisible;
          sticky.setAttribute('aria-hidden',String(!visible));
          sticky.inert = !visible;
        };
        this.stickyObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target.id === 'buy') pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            else finalVisible = entry.isIntersecting;
          });
          updateSticky();
        });
        this.stickyObserver.observe(this.querySelector('#buy'));
        this.stickyObserver.observe(this.querySelector('.hand-final'));
      }
      root.classList.add('wr-js');
      update();
    }
    disconnectedCallback() {
      this.stickyObserver?.disconnect();
      this.initialized = false;
    }
  });
}

